/*
 * @Description: 公共方法
 * @Author: zhanjunwei
 * @Date: 2024-12-05 10:54:07
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-03-26 16:43:32
 */
'use client';
import lodash from 'lodash';
import dayjs from 'dayjs';
import {
  postUploadFile,
  putFileUrl,
  getPreviewUrls,
  getUploadContentType,
} from './useApi/clientCommon';
import { MessagePlugin, UploadFile } from 'tdesign-react';

/**
 * @description: 睡眠方法
 * @param {number} seconds 睡眠的毫秒数
 * @return {*}
 */
export const sleep = (seconds: number) =>
  new Promise((resolve) => {
    let timer: any = setTimeout(() => {
      resolve(true);
      clearTimeout(timer);
      timer = null;
    }, seconds);
  });

// 下载文件
export const downloadFile = ({ url, name }: any) => {
  const p = new Promise((resolve) => {
    fetch(url)
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`下载失败: ${res.status}`);
        }
        const result = await res.blob();
        return result;
      })
      .then((blob) => {
        // 创建隐藏的可下载链接
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        // 保存下来的文件名
        a.download = name;
        document.body.appendChild(a);
        a.click();
        // 移除元素
        document.body.removeChild(a);
        resolve(true);
      })
      .catch(() => {
        resolve(false);
      });
  });
  return p;
};

/**
 * @description: 上传文件
 * @param {} file 单个文件或者文件数组（多文件）
 * @param isValue 是否需要可展示的url
 * @return {}
 */
export const handleUpload = async ({
  file,
  isValue = true,
  module = 'aitools',
}: {
  file: UploadFile | UploadFile[];
  isValue?: boolean;
  module?: string;
}) => {
  let status: 'success' | 'fail' = 'success';
  const { name, raw, size } = lodash.isArray(file) ? file[0] : file;
  const uploadTime = dayjs().format('YYYY-MM-DD');

  const urlencoded = new URLSearchParams();
  urlencoded.append('module', module);
  urlencoded.append('filename', name as string);

  try {
    const itemRes = await postUploadFile(urlencoded);

    const result = await putFileUrl(
      itemRes.url,
      raw,
      getUploadContentType(name as string)
    );

    status = result.status === 200 ? 'success' : 'fail';
    const [url] = itemRes.url.split('?');
    const response = {
      path: itemRes.path,
      url, // 传递给后端的url
      name, // 文件名字
      size, // 文件大小
      uploadTime, // 最后修改时间
      value: undefined,
    };
    if (isValue) {
      const { urls } = await getPreviewUrls({ urls: [url] });
      response.value = urls; // 可展示的url
    }
    return {
      status, // 状态 'success' | 'fail'
      response, // 响应体
    };
  } catch (error) {
    MessagePlugin.error('上传失败');
    new Error('上传失败');
  }
};
